import { Overlay, Table } from "react-bootstrap"

export const Legend = (props) => {
    return (
        <Overlay id="legend-popover" target={props.target.current} show={props.showLegend} placement="bottom">
            {({ placement, arrowProps, show: _show, popper, ...props }) => (
                <div
                    {...props}
                    style={{
                        position: 'center',
                        backgroundColor: '#d1ecf1',
                        padding: '15px 10px',
                        border: 'solid',
                        borderWidth: '3px',
                        borderColor: '#bee5eb',
                        ...props.style
                    }}
                >
                    <Table
                        striped
                        bordered
                        variant="light"
                        style={{
                            backgroundColor: 'white'
                        }}
                    >
                        <thead>
                            <tr>
                                <th>Filter</th>
                                <th>Function</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b>Passed</b></td>
                                <td>Members that have successfully passed provisioning </td>
                            </tr>
                            <tr>
                                <td><b>Failed</b></td>
                                <td> Members that have failed provisioning, or haven't been run through yet </td>
                            </tr>
                            <tr>
                                <td><b>Active</b></td>
                                <td> Members that are marked as Active in Salesforce</td>
                            </tr>
                            <tr>
                                <td><b>Inactive</b></td>
                                <td> Members that are marked Inactive in Salesforce</td>
                            </tr>
                            <tr>
                                <td><b>On Hold</b></td>
                                <td> Members that are on hold in this app (not related to salesforce)</td>
                            </tr>
                            <tr>
                                <td><b>Unassigned</b></td>
                                <td> Members whose account is "Unassigned" in Salesforce</td>
                            </tr>
                            <tr>
                                <td><b>Needs CHR Id</b></td>
                                <td> Members that have either CHR or Notify and are not inactive or unassigned, but do not have a CHR Id</td>
                            </tr>
                            <tr>
                                <td><b>Has Services</b></td>
                                <td> Members with any of the following services selected in Salesforce: CHR, Notify, DSM, Referrals</td>
                            </tr>
                            <tr>
                                <td><b>Doesn't Have Services</b></td>
                                <td> Members that do not have any of the above services</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            )}
        </Overlay>
    )
}